export const AGE_LIMIT_UNDERAGE = 16
export const LOWER_AGE_LIMIT = 16
export const UPPER_AGE_LIMIT = 18

export const DEFAULT_LIMIT = 100
export const MAX_LIMIT = 101

export const CURRENT_POLICY_VERSION = 2

export const EXPERIENCE_LOWER_LIMIT = 0
export const EXPERIENCE_UPPER_LIMIT = 40

export const ACCOUNT_TYPE_PRIVATE = 'private'
export const ACCOUNT_TYPE_CORPORATE = 'corporate'

export const VISIBILITY_PUBLIC = 'public'
export const VISIBILITY_PROTECTED = 'protected'

export const USER_ROLE_ADMIN = 'admin'
export const USER_ROLE_MODERATOR = 'moderator'

export const VIEW_ADVERTISER = 'advertiser'
export const VIEW_EMPLOYER = 'employer'

export const ADDRESS_TYPE_COUNTY = 'administrative_area_level_1'
export const ADDRESS_TYPE_COUNTRY = 'country'
export const ADDRESS_TYPE_CITY = 'locality'
export const ADDRESS_TYPE_DISTRICT = 'sublocality_level_1'
export const ADDRESS_TYPE_POLITICAL = 'political'
export const ADDRESS_TYPE_POSTAL_CODE = 'postal_code'
export const ADDRESS_TYPE_ROUTE = 'route'
export const ADDRESS_TYPE_STREET_NUMBER = 'street_number'

export const STATE_ABORTED = 'aborted'
export const STATE_AVAILABLE = 'available'
export const STATE_CONFIRMED = 'confirmed'
export const STATE_DRAFT = 'draft'
export const STATE_ONGOING = 'ongoing'
export const STATE_PENDING = 'pending'
export const STATE_PROCESSING = 'processing'
export const STATE_USED = 'used'

export const ONE_SECOND_IN_MILLISECONDS = 1000
export const ONE_MINUTE_IN_MILLISECONDS = 60000
export const ONE_YEAR_IN_MILLISECONDS = 365 * 24 * 60 * 60 * 1000

export const PAYMENT_STEP_PACKAGES = 'packages'
export const PAYMENT_STEP_BILLING_INFORMATION = 'billing-information'
export const PAYMENT_STEP_CONFIRM = 'confirm'

export const MOBILE_NAVBAR_HEIGHT = 60

export const DEFAULT_CSS_TRANSITION_DURATION_IN_MILLISECONDS = 150

export const ERROR_INVALID_TOKEN = 'Érvénytelen token'
export const ERROR_EXPIRED_TOKEN = 'Lejárt token'



// WEBPACK FOOTER //
// ./src/constants.js